export default function arrayIncludesAny(array, values) {
  return values.some((value) => array.includes(value));
}
